import { applicationKeys, IApplicationKeyParams } from './applicationKeys';

export interface IApplicationLoanRequestKeyParams
  extends IApplicationKeyParams {
  requestIDs?: string[];
}

export const applicationLoanRequestsKeys = {
  root: (params: IApplicationLoanRequestKeyParams) =>
    [...applicationKeys.loanRequest(params), params.requestIDs] as const,
  loanRequestFilters: (params: IApplicationLoanRequestKeyParams) =>
    [...applicationLoanRequestsKeys.root(params), params.requestIDs] as const,
};

export function parseApplicationLoanRequestsKey<
  T extends keyof typeof applicationLoanRequestsKeys
>(queryKey: ReturnType<(typeof applicationLoanRequestsKeys)[T]>) {
  const [, applicationID, , requestIDs] = queryKey;

  return { applicationID, requestIDs };
}
